export default __webpack_public_path__ + "static/media/envelop.c8d38b9f.svg";